import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Leaf } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Please enter username and password");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, null, {
        auth: { username, password },
      });
      
      // Store credentials in sessionStorage
      sessionStorage.setItem("adminAuth", btoa(`${username}:${password}`));
      toast.success("Login successful!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bone-cream py-16 animate-fade-in">
      <div className="w-full max-w-md mx-auto px-4">
        <div className="bg-white p-8 md:p-10 border border-stone-200">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Leaf className="w-8 h-8 text-deep-moss" />
              <span className="font-serif text-2xl font-semibold text-stone-900">
                WEH Admin
              </span>
            </div>
            <p className="font-sans text-stone-600">Sign in to manage your store</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block font-sans text-sm text-stone-700 mb-2">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="admin-username"
                className="w-full input-underline"
                placeholder="admin"
              />
            </div>

            <div>
              <label className="block font-sans text-sm text-stone-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full input-underline"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-btn"
              className="w-full flex items-center justify-center gap-2 bg-deep-moss hover:bg-deep-moss/90 text-white rounded-full px-6 py-3 font-sans font-medium transition-colors disabled:opacity-50"
            >
              <Lock className="w-4 h-4" />
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
